angular.module('account.login')
    .component('loginComponent', {
        parent: 'unauthenticated',
        bindings: {
            returnTo: '<'
        },
        templateUrl: 'app/account/login/login.html',
        controller: function ($state, $rootScope, Auth, PublicSettingsService) {
            let ctrl = this;

            this.showUEFinancedImage = false;

            this.formData = {
                rememberMe: true
            };

            this.$onInit = () => {
                return PublicSettingsService.get()
                    .then(settings => this.showUEFinancedImage = settings.showUEFinancedImage === true);
            };

            this.login = (event) => {
                event.preventDefault();
                return Auth.login(this.formData)
                    .then(() => {
                        ctrl.authenticationError = false;
                        let state = ctrl.returnTo.state();
                        let params = ctrl.returnTo.params();
                        let options = Object.assign({}, ctrl.returnTo.options());
                        $state.go(state, params, options);
                    })
                    .catch(() => ctrl.authenticationError = true);
            };
        }
    })
